module.exports = __webpack_public_path__ + "img/pic_icare.fd674129.jpg";